var SctFormValidation = /** @class */ (function () {
    function SctFormValidation(url) {
        this.url = url;
        this.url = url;
    }
    SctFormValidation.prototype.urlCheck = function (tool) {
        if ('slack' === tool) {
            var regPattern = /^(?:https|http):\/\/(?:[a-z]{1,}\.|)(?:hooks\.slack\.com)(?:\/(?:.*)|\?(?:.*)|$)$/;
            return regPattern.test(this.url);
        }
        else if ('discord' === tool) {
            var regPattern = /^(?:https|http):\/\/(?:[a-z]{1,}\.|)(?:discord\.com)(?:\/(?:.*)|\?(?:.*)|$)$/;
            return regPattern.test(this.url);
        }
        else if ('chatwork' === tool) {
            var regPattern = /^[0-9a-zA-Z]+$/;
            return regPattern.test(this.url);
        }
        return false;
    };
    return SctFormValidation;
}());
export { SctFormValidation };
